// Collapses / expands a team's member rows on the Month End Close
// dashboard. Attached to the team's <tbody>; the subtotal header row stays
// visible. The chosen state is remembered per team in localStorage so it
// survives filter / sort re-renders of the matrix.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "expandedIcon", "collapsedIcon"];
  static values = { key: String };

  connect() {
    if (window.localStorage.getItem(this.storageKey) === "true") {
      this.setCollapsed(true);
    }
  }

  toggle(event) {
    // Drill-down links inside the subtotal row navigate; they don't toggle.
    if (event?.target.closest("a")) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    const collapsed = !this.rowTargets[0]?.classList.contains("d-none");
    window.localStorage.setItem(this.storageKey, collapsed);
    this.setCollapsed(collapsed);
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      this.toggle(event);
    }
  }

  setCollapsed(collapsed) {
    this.rowTargets.forEach((row) => row.classList.toggle("d-none", collapsed));
    // The carets are FontAwesome SVGs, so swap wrapper spans instead of
    // touching the icon elements themselves.
    this.expandedIconTarget.classList.toggle("d-none", collapsed);
    this.collapsedIconTarget.classList.toggle("d-none", !collapsed);
  }

  get storageKey() {
    return `mec-team-collapse-${this.keyValue}`;
  }
}
